import * as React from 'react'

export const SDKIcon = React.memo<JSX.IntrinsicElements['svg']>((props) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10.6667C8 9.19393 9.19391 8.00002 10.6667 8.00002H48C49.4728 8.00002 50.6667 9.19393 50.6667 10.6667V58.6667C50.6667 60.1394 49.4728 61.3334 48 61.3334H10.6667C9.19391 61.3334 8 60.1394 8 58.6667V10.6667Z"
        fill="#FFD140"
      />
      <path
        d="M13.3333 5.33335C13.3333 3.86059 14.5272 2.66669 16 2.66669H53.3333C54.8061 2.66669 56 3.86059 56 5.33335V53.3334C56 54.8061 54.8061 56 53.3333 56H16C14.5272 56 13.3333 54.8061 13.3333 53.3334V5.33335Z"
        fill="#5BBBFC"
      />
      <path
        d="M50.6667 56H16C14.5272 56 13.3333 54.8061 13.3333 53.3334V8.00002H48C49.4728 8.00002 50.6667 9.19393 50.6667 10.6667V56Z"
        fill="#FAF8F5"
      />
      <path
        d="M44.6667 17.1667C45.0349 17.1667 45.3333 16.8682 45.3333 16.5V15.5C45.3333 15.1318 45.0349 14.8334 44.6667 14.8334H19.3333C18.9651 14.8334 18.6667 15.1318 18.6667 15.5V16.5C18.6667 16.8682 18.9651 17.1667 19.3333 17.1667H44.6667Z"
        fill="#001C64"
      />
      <path
        d="M44.6667 27.8334C45.0349 27.8334 45.3333 27.5349 45.3333 27.1667V26.1667C45.3333 25.7985 45.0349 25.5 44.6667 25.5H19.3333C18.9651 25.5 18.6667 25.7985 18.6667 26.1667V27.1667C18.6667 27.5349 18.9651 27.8334 19.3333 27.8334H44.6667Z"
        fill="#001C64"
      />
      <path
        d="M45.3333 37.8334C45.3333 38.2015 45.0349 38.5 44.6667 38.5H19.3333C18.9651 38.5 18.6667 38.2015 18.6667 37.8334V36.8334C18.6667 36.4652 18.9651 36.1667 19.3333 36.1667H44.6667C45.0349 36.1667 45.3333 36.4652 45.3333 36.8334V37.8334Z"
        fill="#001C64"
      />
      <path
        d="M44.6667 49.1667C45.0349 49.1667 45.3333 48.8682 45.3333 48.5V47.5C45.3333 47.1318 45.0349 46.8334 44.6667 46.8334H19.3333C18.9651 46.8334 18.6667 47.1318 18.6667 47.5V48.5C18.6667 48.8682 18.9651 49.1667 19.3333 49.1667H44.6667Z"
        fill="#001C64"
      />
    </svg>
  )
})

SDKIcon.displayName = 'SDKIcon'
